import angular from 'angular';

import PoiTypeListModalModule from './poi-type-list-modal/poi-type-list-modal';

const Module = angular.module('control-room.poi.components.poi-type-list.components', [PoiTypeListModalModule.name]);

export default Module;
